import {
    Button,
    ButtonProps,
} from "@evidenceb/athena-common/design-system/Button";
import React, { forwardRef } from "react";
import cn from "classnames";

import "./ButtonWithLoadingState.scss";

// Reference: https://www.bekk.christmas/post/2023/24/accessible-loading-button

export type Props = ButtonProps & {
    loading: boolean;
};

const ButtonWithLoadingState = forwardRef<HTMLButtonElement, Props>(
    (
        { loading, label, onPress, onClick, className, style, ...props }: Props,
        ref
    ) => {
        return (
            <Button
                {...props}
                ref={ref}
                className={cn(className, "button-with-loading-state", {
                    "--loading": loading,
                })}
                label={label}
                aria-disabled={loading}
                onPress={loading ? undefined : onPress}
                onClick={loading ? undefined : onClick}
            />
        );
    }
);
export default ButtonWithLoadingState;
